module.exports = __webpack_public_path__ + "static/img/product_society_space.81bd7b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_space.png
// module id = xRWN
// module chunks = 0